export default __webpack_public_path__ + "static/media/wheel-unaccept.613d2c63.png";